import { authenticatedAxios, loginAxios } from '../../utils/axios'
import CONSTANTS from '../../utils/constants'
import ENDPOINTS from '../constant'

export const getAvailableUpgradeSpeeds = async (data) => {
  let responseData = {
    availableUpgradeSpeeds: [],
    error: null,
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.getAvailableUpgradeSpeeds}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.availableUpgradeSpeeds = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while getting available upgrade speeds.'
  }
  return responseData
}

export const checkFiberTool = async (data) => {
  let responseData = { error: null, msg: null, title: null, data: null, responseCode: null, orderId: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.checkFiber}`,
      { params: { speedKey: data.speedKey } }
    )
    responseData.responseCode = res.data.responseCode
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.msg = res.data.responseMessage
      responseData.title = res.data.responseTitle
      responseData.data = res.data.result || null
      responseData.orderId = res.data.result || null // orderId is returned in result field
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while checking fiber tool.'
  }
  return responseData
}

export const getFiberStatusResponse = async (data) => {
  let responseData = { error: null, msg: null, title: null, responseCode: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.fixedLineServices.root}GetFiberStatusResponse`,
      { params: { orderId: data.orderId, recallCount: data.recallCount } }
    )
    responseData.responseCode = res.data.responseCode
    // Always capture responseMessage and responseTitle if available
    if (res.data.responseMessage) {
      responseData.msg = res.data.responseMessage
    }
    if (res.data.responseTitle) {
      responseData.title = res.data.responseTitle
    }
    
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      // Success case - already set msg and title above
    } else if (res.data.responseCode === 30) {
      // Still processing - continue polling
    } else if (res.data.responseCode === 20) {
      // Stop calling the API
    } else {
      // Error case - set error to responseMessage for error handling
      responseData.error = res.data.responseMessage || 'Error while getting fiber status response.'
    }
  } catch (e) {
    responseData.error = 'Error while getting fiber status response.'
  }
  return responseData
}
export const getSuperfastInternetOffers = async (data) => {
  let responseData = {
    offers: [],
    error: null,
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.superfast.root}${ENDPOINTS.fixedLineServices.superfast.getoffers}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.offers = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while getting superfast internet offers.'
  }
  return responseData
}
export const superfastInternetAddOrder = async (data) => {
  let responseData = {
    error: null,
    msg: null,
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.superfast.root}${ENDPOINTS.fixedLineServices.superfast.addorder}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.msg = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while adding superfast internet order.'
  }
  return responseData
}

export const upgradeSpeed = async (data) => {
  let responseData = {
    responseMessage: '',
    error: null,
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.upgradeSpeed}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.responseMessage = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while upgrading the speed.'
  }
  return responseData
}

export const speedUpgradeTermsAndConditions = async () => {
  let responseData = {
    termsAndConditions: [],
    error: '',
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.speedUpgradeTC}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.termsAndConditions = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error =
      'Error accrued while getting Speed upgrade terms and conditions'
  }
  return responseData
}
export const getFiberMigrationOffers = async (data) => {
  let responseData = {
    fiberMigrationOffers: [],
    error: null,
    noAvailability: '',
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.getFiberMigrationOffers}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.fiberMigrationOffers = res.data.result
    } else if (res.data.responseCode === CONSTANTS.NOAVAILABILITY)
      responseData.noAvailability = res.data.responseMessage
    else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued while getting Fiber migration offers'
  }
  return responseData
}
export const addOpportunity = async (data) => {
  let responseData = {
    error: '',
    msg: '',
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.addOpportunity}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.msg = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued while adding opportunity '
  }
  return responseData
}

export const fiberMigrationTermsAndConditions = async () => {
  let responseData = {
    termsAndConditions: [],
    error: '',
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.fiberMigrationTC}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.termsAndConditions = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error =
      'Error accrued while getting Speed upgrade terms and conditions'
  }
  return responseData
}
export const subscribFixedLineOfferFromAPI = async (data) => {
  let responseData = { successfulMsg: '', error: null }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.reconnect}`,
      data
    )

    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.successfulMsg = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.errorMsg = 'Error while offer subscribing'
  }
  return responseData
}
export const getReconnectionEligbleServices = async () => {
  let responseData = {
    reconnectionEligbleServices: [],
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.getReconnectionEligbleServices}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.reconnectionEligbleServices = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error =
      'Error accrued while getting reconnection eligble services'
  }
  return responseData
}
export const fixedLineReconnectTheLine = async (data) => {
  let responseData = { successfulMsg: '', error: null }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.reconnect}`,
      data
    )

    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.successfulMsg = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.errorMsg = 'Error while reconnecting the line'
  }
  return responseData
}
export const getChangeLocationData = async () => {
  let responseData = {
    price: '',
    districts: [],
    disconnectionTypes: [],
    error: '',
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.getChangeLocationData}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.districts = res.data.result.districts
      responseData.disconnectionTypes = res.data.result.disconnectionTypes
      responseData.price = res.data.result.price
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued while getting location Data'
  }
  return responseData
}
export const getDistricts = async () => {
  let responseData = {
    price: '',
    districts: [],
    error: '',
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.getDistricts}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.districts = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued while getting districts'
  }
  return responseData
}
export const fixedLineChangeNumber = async (data) => {
  let responseData = { successfulMsg: '', error: null }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.changeNumber}`,
      data
    )

    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.successfulMsg = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.errorMsg = 'Error while changing the number'
  }
  return responseData
}
export const getFixedLineServiceDetails = async (categoryId) => {
  let responseData = {
    data: [],
    error: '',
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.getServiceDetails}?categoryId=${categoryId}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued while getting service details'
  }
  return responseData
}
export const getQuotaTypesFromAPI = async () => {
  let responseData = { data: [], error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.getExtraQuotaOffers}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'Error while get qouta type'
  }
  return responseData
}
export const getPaltelBook = async (data) => {
  let responseData = { successfulMsg: '', data: [], error: null }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.lineEnquiry}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.successfulMsg = res.data.responseMessage
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.errorMsg = 'Error while changing the number'
  }
  return responseData
}
export const changeLocationTermsAndConditions = async () => {
  let responseData = {
    termsAndConditions: [],
    error: '',
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.changeLocationTC}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.termsAndConditions = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error =
      'Error accrued while getting change location terms and conditions'
  }
  return responseData
}

export const fixedLineChangeLocation = async (data) => {
  let responseData = { successfulMsg: '', error: null }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.changeLocation}`,
      data
    )

    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.successfulMsg = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.errorMsg = 'Error while changing the location'
  }
  return responseData
}
export const uberCallTheRequest = async (data) => {
  let responseData = { successfulMsg: '', error: null }
  try {
    const res = await loginAxios.post(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.uber.root}${ENDPOINTS.fixedLineServices.uber.callRequest}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.successfulMsg = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.errorMsg = 'Error while calling the uber'
  }
  return responseData
}
export const getTechnicalLocation = async (data) => {
  let responseData = { location: {}, successfulMsg: '', error: null }
  try {
    const res = await loginAxios.post(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.uber.root}${ENDPOINTS.fixedLineServices.uber.technicalLocation}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.location = res.data.result
      responseData.successfulMsg = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.errorMsg = 'Error while getting the technicall location'
  }
  return responseData
}
export const addTroubleTicket = async (data) => {
  let responseData = { successfulMsg: '', error: null }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.troubleTicket.root}${ENDPOINTS.fixedLineServices.troubleTicket.add}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.location = res.data.result
      responseData.successfulMsg = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.errorMsg = 'Error while adding a Troble Ticket'
  }
  return responseData
}

export const getTrackOrders = async (data) => {
  let responseData = { successfulMsg: '', data: [], error: null }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.trackOrders}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.successfulMsg = res.data.responseMessage
      responseData.data = res.data.result
    } else if (res.data.responseCode === CONSTANTS.EMPTY_STATE) {
      responseData.successfulMsg = res.data.responseMessage
      responseData.data = []
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.errorMsg = 'Error When Get Tracking Orders'
  }
  return responseData
}
export const getPointsTransaction = async () => {
  let responseData = { data: [], error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.point.root}${ENDPOINTS.fixedLineServices.point.getTransactions}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while getting transactions of points'
  }
  return responseData
}
export const getPointsOffers = async () => {
  let responseData = { data: null, error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.point.root}${ENDPOINTS.fixedLineServices.point.getOffers}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while getting transactions of points'
  }
  return responseData
}
export const redeemPoints = async (data) => {
  let responseData = {
    responseMessage: '',
    code: '',
    error: null,
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.point.root}${ENDPOINTS.fixedLineServices.point.redeem}`,
      data
    )
    if (res.data.responseCode === (CONSTANTS.SUCCESS || 8000)) {
      responseData.responseMessage = res.data.responseMessage
      responseData.code = res.data.responseCode
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while sending Gifts '
  }
  return responseData
}
export const getTroubleTicketTypes = async () => {
  let responseData = { successfulMsg: '', error: null, data: [] }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.troubleTicket.root}${ENDPOINTS.fixedLineServices.troubleTicket.types}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
      responseData.successfulMsg = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.errorMsg = 'Error while adding a Troble Ticket'
  }
  return responseData
}

export const getFixedLineWifiNetworksFromApi = async () => {
  let responseData = {
    error: null,
    data: [],
    msg: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.getWIFINetworks}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseCode
      responseData.msg = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued while getting Fixed Line Wifi Networks'
  }
  return responseData
}

export const getFixedLineWifiBandWidthFromApi = async () => {
  let responseData = {
    data: [],
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.getWIFIBandwidth}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued while getting Fixed Line Wifi BandWidth'
  }
  return responseData
}

export const hasNetworkDeviceConnected = async () => {
  let responseData = {
    hasNetworkDeviceConnected: false,
    error: null,
  }

  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.hasNetworkDeviceConnected}`
    )

    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.hasNetworkDeviceConnected = true
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accured while getting fixed line network device'
  }

  return responseData
}

export const blockNetworkDevice = async (data) => {
  let responseData = {
    error: null,
    responseMessage: '',
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.blockNetworkDevice}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.responseMessage = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error =
      'Error accrued while blocking Fixed Line Network devices'
  }
  return responseData
}

export const getFixedLineDisabledNetworksFromApi = async () => {
  let responseData = {
    data: [],
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.getDisabledWIFINetworks}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued while getting disabled networks'
  }
  return responseData
}
export const getWIFIBandwidthNetworksFromApi = async () => {
  let responseData = {
    data: [],
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.getWIFIBandwidth}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued while getting bandwidth networks'
  }
  return responseData
}

export const getWIFIChannelsNetworksFromApi = async () => {
  let responseData = {
    data: [],
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.getWIFIChannels}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued while getting wifi channels'
  }
  return responseData
}

export const editNetworkSettings = async (data) => {
  let responseData = {
    error: null,
    responseMessage: '',
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.editNetworkSettings}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.responseMessage = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued while editing Network settings'
  }
  return responseData
}

export const getFixedLineWifiNetworkDevicesFromApi = async (data) => {
  let responseData = { successfulMsg: '', data: [], error: null }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.getNetworkDevices}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseCode
    }
  } catch {
    responseData.errorMsg = 'Error When Get network devices'
  }
  return responseData
}

export const checkIsEligibleFiberMigration = async () => {
  let responseData = {
    isEligible: 0,
    msg: null,
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.fiberSchedule.root}${ENDPOINTS.fiberSchedule.isEligibleFiberMigration}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.isEligible = res.data.result
      responseData.msg = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued checking eligiblity'
  }
  return responseData
}

export const getAvailableTimeSlots = async (speed, date) => {
  let responseData = {
    availableTimeSlots: [],
    date: '',
    error: '',
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.fiberSchedule.root}${ENDPOINTS.fiberSchedule.getAvaiableTimeSlot}?date=${date}&speed=${speed}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.availableTimeSlots = res.data.result.timeAndPeriods
      responseData.date = res.data.result.date
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued while getting available Time Slots'
  }
  return responseData
}
export const reserveScheduleFiberMigration = async (data) => {
  let responseData = {
    msg: '',
    error: '',
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.fiberSchedule.root}${ENDPOINTS.fiberSchedule.reserveSchedule}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.msg = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued while reserve schedule Fiber Migration '
  }
  return responseData
}

export const fiberMigrationAddOrder = async (data) => {
  let responseData = {
    error: null,
    msg: null,
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.fiberSchedule.root}${ENDPOINTS.fiberSchedule.addFiberMigrationOrderV2}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.msg = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while adding fiber migration order.'
  }
  return responseData
}

export const getFiberOffersAndAddOn = async () => {
  let responseData = {
    fiberMigrationOffers: [],
    error: null,
    noAvailability: '',
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.fiberSchedule.root}${ENDPOINTS.fiberSchedule.fiberOffersAndAddOn}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.fiberMigrationOffers = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued while getting Fiber migration offers'
  }
  return responseData
}
